import { Modal, ModalOverlay, ModalContent, ModalBody, useDisclosure, Flex, Image, Box } from '@chakra-ui/react'
import { useRef } from 'react'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import { FaSearchPlus } from 'react-icons/fa'
import { Swiper, SwiperSlide } from 'swiper/react'

export function FotosItem({ fotos }) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const swiperRef = useRef()

    return (
        <>
            <Flex onClick={onOpen} cursor="pointer" flex={1} alignItems="center" justifyContent="center" color="#378BBF" gap={2}>
                <FaSearchPlus size={20} />
                fotos item
            </Flex>

            <Modal isOpen={isOpen} onClose={onClose} size="2xl" minH="584px">
                <ModalOverlay />
                <ModalContent>
                    <ModalBody position="relative">
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            onBeforeInit={(swiper) => {
                                swiperRef.current = swiper
                            }}
                        >
                            {fotos?.map((foto, index) => (
                                <SwiperSlide key={index}>
                                    <Flex alignItems="center" justifyContent="center" minH="584px">
                                        <Image src={foto.url} alt={`foto ${index}`} w="100%" h="100%" objectFit="contain" fallbackSrc={foto.url} />
                                    </Flex>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <Box
                            bg="rgba(0, 0, 0, 0.5)"
                            opacity="0.5"
                            _hover={{ opacity: 1 }}
                            h="100%"
                            position="absolute"
                            top="50%"
                            left="0"
                            zIndex="1"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            px={2}
                            transform="translateY(-50%)"
                            onClick={() => swiperRef.current?.slidePrev()}
                            cursor="pointer"
                        >
                            <AiOutlineLeft size={20} color="#fff" />
                        </Box>
                        <Box
                            bg="rgba(0, 0, 0, 0.5)"
                            opacity="0.5"
                            _hover={{ opacity: 1 }}
                            h="100%"
                            position="absolute"
                            top="50%"
                            right="0"
                            zIndex="1"
                            transform="translateY(-50%)"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            px={2}
                            onClick={() => swiperRef.current?.slideNext()}
                            cursor="pointer"
                        >
                            <AiOutlineRight size={20} color="#fff" />
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
